var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53999 19.5206C4.92999 19.5206 4.35999 19.3105 3.94999 18.9205C3.42999 18.4305 3.17999 17.6905 3.26999 16.8905L3.63999 13.6505C3.70999 13.0405 4.07999 12.2305 4.50999 11.7905L12.72 3.10054C14.77 0.930537 16.91 0.870537 19.08 2.92054C21.25 4.97054 21.31 7.11054 19.26 9.28054L11.05 17.9705C10.63 18.4205 9.84999 18.8405 9.23999 18.9406L6.01999 19.4905C5.84999 19.5005 5.69999 19.5206 5.53999 19.5206ZM15.93 2.91054C15.16 2.91054 14.49 3.39054 13.81 4.11054L5.59999 12.8106C5.39999 13.0206 5.16999 13.5206 5.12999 13.8106L4.75999 17.0505C4.71999 17.3805 4.79999 17.6505 4.97999 17.8205C5.15999 17.9905 5.42999 18.0505 5.75999 18.0005L8.97999 17.4506C9.26999 17.4006 9.74999 17.1405 9.94999 16.9305L18.16 8.24054C19.4 6.92054 19.85 5.70054 18.04 4.00054C17.24 3.23054 16.55 2.91054 15.93 2.91054Z",
    fill: "#3A4B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3404 10.9498C17.3204 10.9498 17.2904 10.9498 17.2704 10.9498C14.1504 10.6398 11.6404 8.26985 11.1604 5.16985C11.1004 4.75985 11.3804 4.37985 11.7904 4.30985C12.2004 4.24985 12.5804 4.52985 12.6504 4.93985C13.0304 7.35985 14.9904 9.21985 17.4304 9.45985C17.8404 9.49985 18.1404 9.86985 18.1004 10.2798C18.0504 10.6598 17.7204 10.9498 17.3404 10.9498Z",
    fill: "#3A4B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z",
    fill: "#3A4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.457f5b0ea3a8e9962c7b7e246d4d5880.svg";
export { ForwardRef as ReactComponent };